// ============================================
// TYPES - Data models for shift planning
// ============================================

// Shift types for each person
export type AlenaShift = "earlyMorning" | "morning" | "evening";
export type IlyaShift = "earlyMorning" | "evening" | "night";

// Display names for shifts
export const ALENA_SHIFT_LABELS: Record<AlenaShift, string> = {
  earlyMorning: "←M",
  morning: "M",
  evening: "E",
};

export const ILYA_SHIFT_LABELS: Record<IlyaShift, string> = {
  earlyMorning: "M",
  evening: "E",
  night: "N",
};

// Full names for tooltips
export const SHIFT_FULL_NAMES: Record<string, string> = {
  earlyMorning: "Early Morning",
  morning: "Morning",
  evening: "Evening",
  night: "Night",
};

// Day of week (0 = Sunday, 6 = Saturday)
export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

// Selection state for shifts
export interface AlenaShifts {
  earlyMorning: boolean;
  morning: boolean;
  evening: boolean;
}

export interface IlyaShifts {
  earlyMorning: boolean;
  evening: boolean;
  night: boolean;
}

// Single day schedule
export interface DaySchedule {
  date: string; // ISO date string YYYY-MM-DD
  alena: AlenaShifts;
  ilya: IlyaShifts;
  kindergarten: boolean; // true = садик работает
}

// Week schedule
export interface WeekSchedule {
  weekStart: string; // ISO date string of Sunday
  days: DaySchedule[];
}

// Availability info for a shift
export interface ShiftAvailability {
  canWork: boolean;
  blockedReason?: string;
  exists?: boolean; // false = shift doesn't exist on this day
}

// Availability for all shifts of a person on a day
export interface AlenaAvailability {
  earlyMorning: ShiftAvailability;
  morning: ShiftAvailability;
  evening: ShiftAvailability;
}

export interface IlyaAvailability {
  earlyMorning: ShiftAvailability;
  evening: ShiftAvailability;
  night: ShiftAvailability;
}

// Full availability for a day
export interface DayAvailability {
  alena: AlenaAvailability;
  ilya: IlyaAvailability;
  kindergartenDefault: boolean; // default kindergarten state for this day of week
}

// App state
export interface AppState {
  currentWeekStart: string;
  weeks: Record<string, WeekSchedule>; // keyed by weekStart date
}

// History
export type HistoryChangeType = "shift" | "kindergarten";

export interface HistoryEntry {
  id: number;
  timestamp: string; // ISO timestamp
  username: string;
  date: string; // ISO date YYYY-MM-DD
  changeType: HistoryChangeType;
  person?: "alena" | "ilya"; // for shift changes
  shift?: string; // shift name for shift changes
  oldValue: boolean;
  newValue: boolean;
}
